var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KModal",
    {
      attrs: {
        title: _vm.$tr("serverRestart"),
        submitText: _vm.coreString("continueAction"),
        cancelText: _vm.coreString("cancelAction"),
      },
      on: {
        submit: _vm.handleSubmit,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _vm.changedSetting === "add"
        ? _c("p", { staticClass: "description" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$tr("selectedPath", { path: _vm.path.path })) +
                "\n  "
            ),
          ])
        : _vm._e(),
      _c("p", { staticClass: "description" }, [
        _vm._v("\n    " + _vm._s(_vm.getMessage()) + "\n  "),
      ]),
      _vm.changedSetting === "add" && _vm.path.writable === true
        ? _c(
            "div",
            [
              _c("KCheckbox", {
                attrs: {
                  checked: _vm.confirmationChecked,
                  label: _vm.$tr("makePrimary"),
                  description: _vm.deviceString("primaryStorageLabel"),
                },
                on: {
                  change: function ($event) {
                    _vm.confirmationChecked = $event
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }